import React from "react";
import Homebanner from "../common/Homebanner/Homebanner";
import Housecart from "../common/HouseCard/HouseCard";
import LeastNewsProperty from "../home/LeastNewsProperty";
import LocalAgents from "../home/LocalAgents";
import HeroSection from "../common/Homebanner/HeroSection";
import { useLatestAgents } from "../../Hooks/useLatestAgents/useLatestAgents";

const MainDashBoard = ({ setSearch }) => {
  const { agents, featuredAgent, loading, error, refetch } = useLatestAgents();

  return (
    <>
      <div className="hero_section mx-auto w-full max-w-full overflow-x-hidden my-4">
        <HeroSection featuredAgent={featuredAgent} agentLoading={loading} />
        <Homebanner setSearch={setSearch} />
        <LocalAgents
          agents={agents}
          loading={loading}
          fetchError={error}
          onRetry={refetch}
        />
        <Housecart />
        {/* <TabbingProperty /> */}
        <LeastNewsProperty />
        {/* <Developmentcart /> */}
        {/* <BenefitsCard /> */}
        {/* <NewsCard /> */}
        {/* <CompareLoans /> */}
      </div>
    </>
  );
};

export default MainDashBoard;
